export const SSN = "SSN";
export const EIN = "EIN";
